var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tree_list"},[_c('Card',{staticStyle:{},attrs:{"title":"我的目录","icon":"ios-options","padding":0,"shadow":""}}),_c('Tree',{attrs:{"data":_vm.tree_list},on:{"on-select-change":_vm.tree_click}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }